import * as actionTypes from "../actions/actionTypes";
import QuestionSets from "../../libs/QuestionSets";
import { updateObject } from "../utility";

const initialState = {
  currentQuestions: [...QuestionSets["Select Your Role"]],
  currentLabels: [
    ...QuestionSets["Select Your Role"].map((qset) => qset.currH),
  ],
  currentQuestion: 0,
};

const choose_questions = (state = initialState, action) => {
 // Spider__legend fix
  const curLbls = QuestionSets[action.role].map(
    (qset) => (qset.currH = qset.headerSet)
  );

  return updateObject(state, {
    currentQuestions: [...QuestionSets[action.role]],
    currentLabels: curLbls,
  });
};

const nav_question = (state = initialState, action) => {
  return updateObject(state, {
    currentQuestion: state.currentQuestion + action.dir,
  });
};

const reducer = (state = initialState, action) => {
  if (action.type === actionTypes.CHOOSE_QUESTIONS) {
    return choose_questions(state, action);
  }
  if (action.type === actionTypes.NAV_QUESTION) {
    return nav_question(state, action);
  }
  return state;
};

export default reducer;
